import { type ReactNode } from 'react';
import { type IngredientViewModel } from '../../../../../Ingredient/Ingredient';
import styles from './EditButtons.module.css';

interface Props {
  testid?: string;
  ingredient: IngredientViewModel;
  removed: boolean;
  onAddClick?: () => void;
  onRemoveClick?: () => void;
  onSwapClick?: () => void;
  editorIcons: { swap: ReactNode; remove: ReactNode; add: ReactNode };
}

export function EditButtons(props: Props) {
  const {
    onAddClick,
    onRemoveClick,
    onSwapClick,
    testid,
    removed,
    editorIcons,
  } = props;
  return (
    <>
      {onSwapClick !== undefined && (
        <button
          className={styles['swap']}
          onClick={onSwapClick}
          aria-label="swap"
          data-testid={`${testid}-button-swap`}
        >
          {editorIcons.swap}
        </button>
      )}
      {removed === true && onAddClick !== undefined && (
        <button
          className={styles.add}
          onClick={onAddClick}
          aria-label="add"
          data-testid={`${testid}-button-add`}
        >
          {editorIcons.add}
        </button>
      )}
      {removed === false && onRemoveClick !== undefined && (
        <button
          key="remove"
          className={styles['modify-button']}
          onClick={onRemoveClick}
          aria-label="remove"
          data-testid={`${testid}-button-remove`}
        >
          {editorIcons.remove}
        </button>
      )}
    </>
  );
}
